package com.wintermar.inspection.core.ui.component.snackbar.util

enum class SnackBarPosition {
    TOP,
    BOTTOM
}
